import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { apiGetListProffitSearchShare } from '../../../../actions/ProffitSearchSlideActions';
import { propShape } from '../../../../helpers/custom-prop-types';
import { compose } from '../../../../helpers/recompose';
import AuthenticationHoc from '../../../System/AuthenticationHoc';
import ProffitSearchInformationHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchInformationHoc';
import ProffitSearchRegistrationDeviceHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchRegistrationDeviceHoc';
import ProffitSearchShareHistoryHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchShareHistoryHoc';
import ProffitSearchTutorialHoc from '../../../Ui/ProffitSearch/Hoc/ProffitSearchTutorialHoc';
import SlideSearchListOneTemplate from '../../List/SlideSearchListOneTemplate';
import SharedUser from './Parts/ShareHistroy/ShareList/SharedUser';
const ShareHistoryOne = (props) => {
    const { proffitSearch, share } = props;
    const { content, createdAt, id, members } = share;
    const profile = useSelector((state) => state.profile);
    const { file, firstName, lastName } = useMemo(() => {
        const { information = {} } = profile || {};
        return information;
    }, [profile]);
    const pans = useMemo(() => [
        {
            link: '/mypage',
            text: 'マイページ',
        },
        {
            link: '/proffit_search',
            text: 'PROFFIT SEARCH',
        },
        {
            link: '/proffit_search/share_history',
            text: 'フォルダ',
        },
        {
            text: '共有ファイル',
        },
    ], []);
    const wrapAction = useCallback((params, meta) => apiGetListProffitSearchShare(id, params, meta), [id]);
    return (_jsx(SlideSearchListOneTemplate, { action: wrapAction, keywordPlaceholder: '共有スライドの検索', pans: pans, proffitSearch: proffitSearch, renderHeader: () => (_jsx(SharedUser, { content: content, createdAt: createdAt, firstName: firstName, lastName: lastName, members: members, photo: file })) }));
};
ShareHistoryOne.propTypes = {
    proffitSearch: propShape().isRequired,
    share: propShape().isRequired,
};
const enhance = compose(AuthenticationHoc({ isCanUseProffitSearch: true }), ProffitSearchRegistrationDeviceHoc(), ProffitSearchTutorialHoc(), ProffitSearchInformationHoc(), ProffitSearchShareHistoryHoc());
export default enhance(ShareHistoryOne);
